export function updateWeaponFires(roundData, currentTick, previousTick, getConvertedCords, pixelsPerMapUnit, frameRate, existingFires = []) {
  if (!roundData || !roundData.weaponFires) return [];

  const now = Date.now();
  const activeFires = [];
  const ppu = pixelsPerMapUnit || 1;

  const FIRE_OFFSET_U = 10;
  const FIRE_RADIUS_U = 12;
  const FIRE_RECT_WIDTH_U = 0.35;
  const FIRE_RECT_HEIGHT_U = 8.5;
  const FIRE_HEIGHT_GROWTH_U = 70;

  existingFires.forEach((fire) => {
    const elapsed = now - fire.startTime;
    const progress = Math.min(1, elapsed / fire.duration);

    if (progress >= 1) {
      return;
    }

    const time = elapsed / 1000;
    const sinInput = time / (1000 / (frameRate * 4)) + 1.3;
    fire.scale = Math.sin(sinInput);

    const heightGrowth = FIRE_HEIGHT_GROWTH_U * (elapsed / (1000 / frameRate / 4)) * ppu;
    fire.currentHeight = fire.rectHeight + heightGrowth;

    activeFires.push(fire);
  });

  const tickFireEvents = roundData.weaponFires.filter(
    (event) => event.tick > previousTick
      && event.tick <= currentTick
      && event.weaponClass !== 'Grenade'
      && event.playerX !== undefined
      && event.playerY !== undefined,
  );

  tickFireEvents.forEach((event) => {
    const cords = getConvertedCords(event.playerX, event.playerY);
    if (!cords) return;

    if (event.playerViewX === undefined) return;

    const angleInDegrees = -event.playerViewX + 90;
    const angleInRadians = (angleInDegrees * Math.PI) / 180;

    const xOffset = FIRE_OFFSET_U * Math.sin(angleInRadians) * ppu;
    const yOffset = FIRE_OFFSET_U * Math.cos(angleInRadians) * ppu;

    const baseRadius = FIRE_RADIUS_U * ppu;
    const baseRectWidth = FIRE_RECT_WIDTH_U * ppu;
    const baseRectHeight = FIRE_RECT_HEIGHT_U * ppu;

    const animationDuration = 1000 / (frameRate * 4);

    activeFires.push({
      id: `fire-${event.tick}-${event.playerSteamID}`,
      circleX: cords.x + xOffset,
      circleY: cords.y - yOffset,
      rectX: cords.x,
      rectY: cords.y,
      angle: angleInDegrees - 180,
      radius: baseRadius,
      rectWidth: baseRectWidth,
      rectHeight: baseRectHeight,
      startTime: now,
      duration: animationDuration,
      opacity: 0.5,
      rectOpacity: 0.5,
      scale: 1.0,
      currentHeight: baseRectHeight,
    });
  });

  return activeFires;
}
